import { useMemo } from "react";
import Highlighter from "react-highlight-words";
import { FormattedMessage, useIntl } from "react-intl";

import {
    highlightStyle,
    ScrollContainer,
} from "@/components/atom/QuestionsListItems/QuestionsListItems.styles";
import { EFaqsCategoryIcons } from "@/store/faq/config";
import { TFAQsItem } from "@/store/faq/types";

type QuestionsListItemsProps = {
    isOnboarding: boolean;
    faqsList: TFAQsItem[];
    searchValue: string;
    handleSelection: (faq: TFAQsItem) => void;
};

const QuestionsListItems = ({isOnboarding, faqsList, searchValue, handleSelection}: QuestionsListItemsProps) => {

    const intl = useIntl();

    const onboardingQuestion: TFAQsItem = useMemo(
        () => ({
            id: "onboardingQuestion",
            name: intl.formatMessage({
                id: "chatPage.servicesSection.exemplary_questions_onboarding_one",
            }),
            icon: EFaqsCategoryIcons.PERFORM,
            type: EFaqsCategoryIcons.PERFORM,
            tooltipText: "chatPage.chatInput.tooltip.stats",
        }),
        [intl]
    );

    const faqsToRender = useMemo<TFAQsItem[]>(
        () => (isOnboarding ? [onboardingQuestion] : faqsList),
        [isOnboarding, onboardingQuestion, faqsList]
    );

    if (faqsToRender.length === 0) {
        return (
            <ScrollContainer>
                <div className="list-group border rounded margin-bottom-20">
                    <div className="list-group-item list-group-item-link">
                        <FormattedMessage id="chatPage.servicesSection.exemplary_questions.noExampleQuestions" />
                    </div>
                </div>
            </ScrollContainer>
        );
    }

    return (
        <ScrollContainer>
            <div data-testid="example-questions-list" className="list-group border rounded margin-bottom-20">
                {faqsToRender.map((faq) => (
                    <button
                        key={`filter-${faq.id}`}
                        className={`list-group-item list-group-item-link ${
                            faq.id === "onboardingQuestion"
                                ? "list-group-item-primary bg-highlight-lightest"
                                : ""
                        }`}
                        onClick={() => handleSelection(faq)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") handleSelection(faq);
                        }}
                    >
                        <Highlighter
                            highlightStyle={highlightStyle}
                            searchWords={[searchValue]}
                            autoEscape
                            textToHighlight={faq.name}
                        />
                    </button>
                ))}
            </div>
        </ScrollContainer>
    );
};

export default QuestionsListItems;
